export const AI_LIMIT_REACHED_MESSAGE = 'Weekly AI limit reached — resets next week';
export const AI_TIMEOUT_MESSAGE =
  'This is taking longer than expected — your request may still be finishing. Please wait a moment and try again.';

/**
 * Classifies an AI endpoint failure into a consistent, user-facing message.
 * @param {Object} err - Axios error
 * @param {string} fallbackMessage - Message to use when the error isn't a known 402/timeout shape
 * @returns {string}
 */
export function getAiErrorMessage(err, fallbackMessage) {
  if (err.response?.status === 402) {
    return AI_LIMIT_REACHED_MESSAGE;
  }
  if (err.code === 'ECONNABORTED') {
    return AI_TIMEOUT_MESSAGE;
  }
  return fallbackMessage;
}
